import Loading from '@Components/Loading/Loading'
import React from 'react'
import { connect } from 'react-redux'
import Header from '../Header/Header'
import './InspectionLayout.scss'

interface IInspectionLayout {
    children: React.ReactNode
    isLoading?: boolean
}

const InspectionLayout = ({ children, isLoading }: IInspectionLayout) => {
    return (
        <div className="inspection-layout">
            <Header />
            <div className="inspection-wrapper">
                <div className="inspection-content">
                    <Loading isLoading={isLoading} />
                    {children}
                </div>
            </div>
        </div>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const isLoading = state?.shared?.loadings?.pageLoading
    return {
        isLoading,
    }
}
export default connect(mapStateToProps, null)(InspectionLayout)
